import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialButton from "../../../components/MaterialButton";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import {
  createProductMaster,
  getProductById,
  productDataMange,
  productMasterData,
  updateProductMaster,
} from "./productData";
import MaterialSelect from "../../../components/MasterSelect";
import { allBrands } from "../brand/brandData";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { allProductCategories } from "../productCategory/productCategoryData";
import ImageSelector from "../../components/ImageSelector";
import { useLoading } from "../../../context/LodingContext";
import { useMutation } from "@apollo/client";
import Swal from "sweetalert2";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import MaterialAvatar from "../../../components/MaterialAvatar";

const ProductMasterForm = () => {
  const [productData, dispatch] = useReducer(
    productDataMange,
    productMasterData
  );
  const [brandLoading, setBrandLoading] = useState(false);
  const [catgoreyLoading, setCatgoreyLoading] = useState(false);
  const [inputDisble, setInputDisble] = useState(false);
  const [productBrandOption, setProductBrandOption] = useState([]);
  const [productcategoryOption, setProductcategoryOption] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [brandCodeOption, setBrandCodeOption] = useState([]);
  const { setCirleLoading } = useLoading();
  const [createBrand, { loading, error }] = useMutation(createProductMaster);
  const [UpdateBrand] = useMutation(updateProductMaster);
  const navigate = useNavigate();
  const location = useLocation();
  const { authenticated, setAuthenticated, userId, setUserID } = useAuthData();
  const formType = location?.state?.type;
  const formValue = location?.state?.data;
  const rowId = location?.state?.rowId;

  useEffect(() => {
    fetchdata();
    fetchCategorydata();
  }, []);

  useEffect(() => {
    if (rowId) {
      fetchById(rowId);
    }
  }, [rowId]);

  const fetchById = async (id) => {
    try {
      const response = await request(BASEURL, getProductById, {
        id: id,
      });

      console.log(response, "response");
    } catch (error) {
    } finally {
    }
  };

  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.productCode,
        name: "productCode",
      });
      dispatch({
        value: formValue?.productName,
        name: "productName",
      });
      dispatch({
        value: {
          value: formValue?.productCategory,
          label: formValue?.productCategory,
        },
        name: "productCategory",
      });
      dispatch({
        value: {
          value: formValue?.productBrand,
          label: formValue?.productBrand,
        },
        name: "productBrand",
      });
      dispatch({
        value: {
          value: formValue?.productBrandCode,
          label: formValue?.productBrandCode,
        },
        name: "brandCode",
      });
      dispatch({
        value: formValue?.baseUom,
        name: "baseUom",
      });
      dispatch({
        value: formValue?.productUom,
        name: "productUom",
      });
      dispatch({
        value: formValue?.conversion,
        name: "conversion",
      });
      dispatch({
        value: formValue?.bas,
        name: "bas",
      });
      dispatch({
        value: formValue?.vat,
        name: "vat",
      });
      dispatch({
        value: formValue?.cod,
        name: "cod",
      });
      dispatch({
        value: formValue?.csh,
        name: "csh",
      });
      dispatch({
        value: formValue?.smt,
        name: "smt",
      });
      dispatch({
        value: formValue?.vansl,
        name: "vansl",
      });
      dispatch({
        value: formValue?.productImage,
        name: "productImage",
      });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      productData.productNameStatus === "success" &&
      productData.productCategoryStatus === "success" &&
      productData.productBrandStatus === "success" &&
      productData.productUomStatus === "success" &&
      productData.baseUomStatus === "success" &&
      productData.conversionStatus === "success" &&
      productData.basStatus === "success" &&
      productData.codStatus === "success" &&
      productData.cshStatus === "success" &&
      productData.smtStatus === "success" &&
      productData.vanslStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const fetchdata = () => {
    setBrandLoading(true);
    request(BASEURL, allBrands)
      .then((res) => {
        const success = res?.allBrands?.success;
        const message = res?.allBrands?.message;
        if (success) {
          setProductBrandOption(res?.allBrands?.data);
          setBrandCodeOption(res?.allBrands?.data);
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
          setProductBrandOption([]);
        }
      })

      .finally(() => {
        setBrandLoading(false);
      });
  };

  const fetchCategorydata = () => {
    setCatgoreyLoading(true);

    request(BASEURL, allProductCategories)
      .then((res) => {
        const success = res?.allProductCategories?.success;
        const message = res?.allProductCategories?.message;
        if (success) {
          setProductcategoryOption(res?.allProductCategories?.data);
        } else {
          setProductcategoryOption([]);
        }
      })

      .finally(() => {
        setCatgoreyLoading(false);
      });
  };
  const handleImageSelect = (file) => {
    dispatch({ value: file, name: "productImage" });
  };

  const handleAdd = async () => {
    setCirleLoading(true);

    try {
      const response = await createBrand({
        variables: {
          input: {
            user: userId,
            productCode: productData?.productCode,
            productName: productData?.productName,
            productCategory: productData?.productCategory?.label,
            productBrandCode: productData?.brandCode?.label,
            productBrand: productData?.productBrand?.label,
            productUom: productData?.productUom,
            baseUom: productData?.baseUom,
            conversion: productData?.conversion,
            vat: productData?.vat,
            bas: productData?.bas,
            cod: productData?.cod,
            csh: productData?.csh,
            smt: productData?.smt,
            vansl: productData?.vansl,
            productImage: productData?.productImage,
          },
        },
        context: { hasUpload: true },
      });
      console.log(response, "response");

      const res = response?.data?.createProduct?.success;
      const message = response?.data?.createProduct?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/product-masters");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdateBrand = async () => {
    setCirleLoading(true);

    try {
      const response = await UpdateBrand({
        variables: {
          input: {
            productId: formValue?.id,
            productCode: productData?.productCode,
            productName: productData?.productName,
            productCategory: productData?.productCategory?.label,
            productBrandCode: productData?.brandCode?.label,
            productBrand: productData?.productBrand?.label,
            productUom: productData?.productUom,
            baseUom: productData?.baseUom,
            conversion: productData?.conversion,
            vat: productData?.vat,
            bas: productData?.bas,
            cod: productData?.cod,
            csh: productData?.csh,
            smt: productData?.smt,
            vansl: productData?.vansl,
            productImage: productData?.productImage?.name
              ? productData?.productImage
              : null,
          },
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.updateProduct?.success;

      const message = response?.data?.updateProduct?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/product-masters");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleDownload = async () => {
    const imageUrl = formValue?.productImage;
    if (!imageUrl) return;

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "item_image.jpg";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <DashboardLayout>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
      >
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            p: 0,
          }}
        >
          {ImageSelector ? (
            <img
              src={formValue?.productImage}
              alt="Item"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "8px",
                objectFit: "contain",
                display: "block",
              }}
            />
          ) : (
            <MaterialTypography>No image available</MaterialTypography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
          {formType == "view" ? (
            <Button onClick={handleDownload}>Download</Button>
          ) : (
            ""
          )}
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Product Master Details"
                    : formType == "edit"
                    ? "Edit Product Master Details"
                    : "View Product Master Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Brand Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="brandCode"
                  value={productData?.brandCode}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={brandCodeOption?.map((item) => {
                    return {
                      value: item?.brandCode,
                      label: item?.brandCode,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  error={productData.brandCodeStatus === "error" ? true : false}
                  success={
                    productData.brandCodeStatus === "success" ? true : false
                  }
                  isLoading={catgoreyLoading}
                  isClearable
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Category Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="productCategory"
                  value={productData?.productCategory}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={productcategoryOption?.map((item) => {
                    return {
                      value: item?.categoryCode,
                      label: item?.categoryCode,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  error={
                    productData.productCategoryStatus === "error" ? true : false
                  }
                  success={
                    productData.productCategoryStatus === "success"
                      ? true
                      : false
                  }
                  isLoading={catgoreyLoading}
                  isClearable
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Item Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productData?.productCode}
                  name="productCode"
                  placeholder="Enter Product Code"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productCode" })
                  }
                  error={
                    productData.productCodeStatus === "error" ? true : false
                  }
                  success={
                    productData.productCodeStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Item Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productData?.productName}
                  name="productName"
                  placeholder="Enter Item name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productName" })
                  }
                  error={
                    productData.productNameStatus === "error" ? true : false
                  }
                  success={
                    productData.productNameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Item Brand <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="productBrand"
                  value={productData?.productBrand}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={productBrandOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.brandName,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  error={
                    productData.productBrandStatus === "error" ? true : false
                  }
                  success={
                    productData.productBrandStatus === "success" ? true : false
                  }
                  isLoading={brandLoading}
                  isClearable
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productData?.baseUom}
                  name="baseUom"
                  placeholder="Enter Base UOM"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "baseUom" })
                  }
                  error={productData.baseUomStatus === "error" ? true : false}
                  success={
                    productData.baseUomStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Least UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productData?.productUom}
                  name="productUom"
                  placeholder="Enter UOM"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productUom" })
                  }
                  error={
                    productData.productUomStatus === "error" ? true : false
                  }
                  success={
                    productData.productUomStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Conversion <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productData?.conversion}
                  type="number"
                  name="conversion"
                  placeholder="Enter Conversion"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "conversion" })
                  }
                  error={
                    productData.conversionStatus === "error" ? true : false
                  }
                  success={
                    productData.conversionStatus === "success" ? true : false
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    VAT <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productData?.vat}
                  type="number"
                  name="vat"
                  placeholder="Enter VAT"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "vat" })
                  }
                  error={productData.vatStatus === "error" ? true : false}
                  success={productData.vatStatus === "success" ? true : false}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    BAS <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={productData?.bas}
                  type="number"
                  name="bas"
                  placeholder="Enter BAS"
                  disabled={inputDisble}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (Number(value) >= 0 || value === "") {
                      dispatch({ value: e?.target?.value, name: "bas" });
                    }
                  }}
                  error={productData.basStatus === "error" ? true : false}
                  success={productData.basStatus === "success" ? true : false}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    COD <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="number"
                  value={productData?.cod}
                  name="cod"
                  placeholder="Enter COD"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "cod" })
                  }
                  error={productData.codStatus === "error" ? true : false}
                  success={productData.codStatus === "success" ? true : false}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    CSH <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="number"
                  value={productData?.csh}
                  name="csh"
                  placeholder="Enter CSH"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "csh" })
                  }
                  error={productData.cshStatus === "error" ? true : false}
                  success={productData.cshStatus === "success" ? true : false}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    SMT <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="number"
                  value={productData?.smt}
                  name="smt"
                  placeholder="Enter SMT"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "smt" })
                  }
                  error={productData.smtStatus === "error" ? true : false}
                  success={productData.smtStatus === "success" ? true : false}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    VANSL <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="number"
                  value={productData?.vansl}
                  name="vansl"
                  placeholder="Enter VANSL"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "vansl" })
                  }
                  error={productData.vanslStatus === "error" ? true : false}
                  success={productData.vanslStatus === "success" ? true : false}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Item Image
                  </MaterialTypography>
                </MaterialBox>

                <FullscreenIcon
                  fontSize="small"
                  className="viewIcon"
                  onClick={() => {
                    setDialogOpen(true);
                  }}
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                />

                <ImageSelector
                  onImageSelect={handleImageSelect}
                  imageUrl={formValue?.productImage}
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/product-masters")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAdd : handleUpdateBrand}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default ProductMasterForm;
